/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".full-screen[_ngcontent-%COMP%]   .col[_ngcontent-%COMP%]:empty, .full-screen[_ngcontent-%COMP%]   [class^=col-][_ngcontent-%COMP%]:empty{display:none}.custom-text[_ngcontent-%COMP%]{font:initial}"];
export { styles as styles };
